import React, { useState }  from 'react';
import ISDcodes from './ISDcodes';

const PhoneNumberInput = ({ type, label, value, value_ISD, id, onChange, status, required}) => {

   

    return (
        <div className="row mt-2">
            <div className="col-md-15"><label className="labels">{label}</label></div>
            <div className="col-md-14">
                
            <div className="phone-number-input">
            <div className="col-md-13">
                <select  id="mobile_ISD" name="mobile_ISD" value={value_ISD} onChange={onChange}>
                    {ISDcodes.map((isd) => (
                        <option key={isd.id} value={isd.code}>
                            {isd.country} ({isd.code})
                        </option>
                    ))}
                </select>
                </div>
                <div className="col-md-14">

                <input type={type} className="form-control" id={id} name={id} value={value} onChange={onChange} required={required}  onKeyDown={(e) => {
        if (['e', 'E', '+', '-', '.'].includes(e.key)) {
            e.preventDefault(); // Prevent invalid characters from being typed
        }
    }}
    onPaste={(e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^\d*$/.test(paste)) {
            e.preventDefault(); // Prevent pasting non-numeric characters
        }
    }} />
                </div>
                </div>
                </div>
                <div className="col-md-22"><label className="labels">{status}</label></div>
                
                
            

            

        </div>
    );
};

export default PhoneNumberInput;
